export default {
  contactUrl: 'https://www.myjamboreegh.com/ajax_req.php',
  playhouseRegistrationUrl: 'https://www.myjamboreegh.com/controller/register.php',
  // playhouseRegistrationUrl: 'http://localhost:4000/controller/register.php',
  fileUploaderUrl: 'https://www.myjamboreegh.com/controller/uploader.php',
};
